// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import GuardiansController from "./guardians_controller"
application.register("guardians", GuardiansController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TableController from "./table_controller"
application.register("table", TableController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TrLinkController from "./tr_link_controller"
application.register("tr-link", TrLinkController)

import TypeaheadController from "./typeahead_controller"
application.register("typeahead", TypeaheadController)
